import { Component, Output, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { SelectOption } from '../teiasoft-select/teiasoft-select.component';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { TeiasoftToasterService } from '../../services/teiasoft-bucket/teiasoft-toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { TTButton } from '../teiasoft-toolbar/teiasoft-toolbar.component';
import { ToggleObject } from '../teiasoft-toggle/teiasoft-toggle.component';
import { Autocomplete } from '../teiasoft-input/teiasoft-input.component';
import { Globals } from '../../globals/globals';
import { UtilsService } from '../../services/utils/utils.service'; // MQBF- 21
import { DatePipe } from '@angular/common';
import { ItemParametersValues } from '../../models/data/itemParametersValues.model';
import { RoundDigit } from '../../models/data/roundDigit.model';
import { TeiasoftLoaderService } from '../../services/teiasoft-bucket/teiasoft-loader.service';
import { AttachmentToUpdate, EnquiryAttachment, EnquiryAttachmentToDelete } from '../../models/data/enquiry.model';

declare var $: any;

export class DialogList {
  field?: string;
  value?: string;
}

export class DialogSelect {
  field?: string;
  option?: SelectOption;
}

export class DialogButton {
  id?: number;
  text?: string;
  buttonType?: string;
  action?: string;
  disabled?: boolean;
  visible?: boolean;
  secondaryAction?: string;
  secondaryActionIcon?: string;
}

export class DialogForm {
  id?: number;
  labelText?: string;
  isRequired?: boolean;
  type?: string;
  field?: string;
  value?: any;
  disabled?: boolean;
  placeHolder?: string;
  optionsList?: SelectOption[];
  fullWidth?: boolean;
  isValid?: boolean;
  toolbarButtonsList?: TTButton[];
  visible?: boolean;
  readOnly?: boolean;
  text?: any;
  refClassWidth?: string;
  autoComplete?: boolean;
  autoCompleteDataset?: any[];
  autoCompleteColumns?: string[];
  autoCompleteColumnsToHide?: string[];
  autoCompleteField?: string;
  columnsWidthPerc?: number[];
  showCreate?: boolean;
  anchor?: string;
  selectable?: boolean;
  multiSelection?: boolean;
  maxLength?: number;
  roundDigits?: number | null;
  colSpan?: number | null;
  minDate?: Date | null;
  maxDate?: Date | null;
}

export class DialogObject {
  action?: string;
  dialogForm?: DialogForm[];
  attachmentsToUpdate?: AttachmentToUpdate[] | null;
  attachmentsToDelete?: EnquiryAttachmentToDelete[] | null;
}

@Component({
  selector: 'teiasoft-dialog',
  templateUrl: './teiasoft-dialog.component.html',
  styleUrls: ['./teiasoft-dialog.component.scss']
})

export class TeiasoftDialogComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() dialogTitle: string = "";
  @Input() dialogIcon: string = "";
  @Input() theme: string = "silver";
  @Input() isMobile: boolean = false;
  @Input() dialogButtons: DialogButton[] = new Array();
  @Input() dialogForm: DialogForm[] = new Array();
  @Input() display: string = 'columns';
  @Input() defaultValue: string = '';
  @Input() elementPerRow: number = 2;
  @Input() roundDigitsForEnquiryForm: RoundDigit[] = new Array();
  @Input() enquiryAttachments: EnquiryAttachment[] = new Array();
  @Input() enquiryNo: string = "";


  @Output() onFormReady: EventEmitter<boolean> = new EventEmitter();
  @Output() onButtonClick: EventEmitter<DialogObject> = new EventEmitter();
  @Output() onFormButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() onFormSelectChanged: EventEmitter<DialogSelect> = new EventEmitter();
  @Output() onFormToggleChanged: EventEmitter<DialogForm> = new EventEmitter();
  @Output() onFormSelectListChanged: EventEmitter<DialogList> = new EventEmitter();
  @Output() onFormAutocompleteChanged: EventEmitter<Autocomplete> = new EventEmitter();
  @Output() onFormAutocompleteChangedRows: EventEmitter<Autocomplete> = new EventEmitter();
  @Output() onFormAutocompletLinkClicked: EventEmitter<any> = new EventEmitter();
  @Output() onFormAutocompleteInputChange: EventEmitter<Autocomplete> = new EventEmitter();
  @Output() onFormAutocompleteRemoveElement: EventEmitter<Autocomplete> = new EventEmitter();

  form?: FormGroup;
  oldDialogForm: DialogForm[] = new Array();
  // itemParameterValues: ItemParametersValues = new ItemParametersValues();

  action: string = "create";

  /* ATTACHMENTS */
  attachmentsToUpdate: AttachmentToUpdate[] = new Array();
  listAttachToDelete: EnquiryAttachmentToDelete[] = new Array();
  isDragging: boolean = false;


  constructor(private fb: FormBuilder, private teiasoftToaster: TeiasoftToasterService, private translateService: TranslateService, public globals: Globals,
    private utilsService: UtilsService, private datePipe: DatePipe, private teiasoftLoader: TeiasoftLoaderService, private translate: TranslateService) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.onFormReady.emit(true);
    $('body').addClass('no-scroll');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["dialogTitle"]) {
      this.dialogTitle = changes["dialogTitle"].currentValue;
    }

    if (changes && changes["dialogIcon"]) {
      this.dialogIcon = changes["dialogIcon"].currentValue;
    }

    if (changes && changes["dialogButtons"]) {
      this.dialogButtons = new Array();
      this.dialogButtons = changes["dialogButtons"].currentValue;
    }

    if (changes && changes["roundDigitsForEnquiryForm"]) {
      this.roundDigitsForEnquiryForm = new Array();
      this.roundDigitsForEnquiryForm = changes["roundDigitsForEnquiryForm"].currentValue;
      this.setRoundDigitsEnquiryForm();
    }


    if (changes && changes["dialogForm"]) {
      this.dialogForm = new Array();
      this.dialogForm = changes["dialogForm"].currentValue;
      if (!this.oldDialogForm) this.dialogForm = new Array();
      if (this.dialogForm.length == 0) this.oldDialogForm = JSON.parse(JSON.stringify(changes["dialogForm"].currentValue));
      this.form = this.fb.group({});
      this.setForm();
      let _i: number = this.dialogForm.findIndex(x => x.field == "customerName");
      if (_i != -1) {
        if (this.dialogForm[_i].value != '') {
          this.action = 'edit';
          this.isFormValid();
        }
      }
    }

    if (changes && changes["display"]) {
      this.display = changes["display"].currentValue;
    }

    if (changes && changes["elementPerRow"]) {
      this.elementPerRow = changes["elementPerRow"].currentValue;
    }

    if (changes && changes["enquiryNo"]) {
      this.enquiryNo = changes["enquiryNo"].currentValue;
    }

    if (changes && changes["enquiryAttachments"]) {
      this.enquiryAttachments = new Array();
      this.enquiryAttachments = changes["enquiryAttachments"].currentValue;
    }

  }

  ngOnDestroy(): void {
    $('body').removeClass('no-scroll');
  }

  setForm() {
    for (var x = 0; x < this.dialogForm.length; x++) {
      this.dialogForm[x].isValid = true;
      this.form!.addControl(this.dialogForm[x].field!, this.fb.control('', Validators.required));
    }
    this.setRoundDigitsEnquiryForm();
  }

  isFormValid(): boolean {
    let _ret: boolean = true;
    for (var x = 0; x < this.dialogForm.length; x++) {
      let _field: string = this.dialogForm[x].field!;
      if (this.dialogForm[x].isRequired && (this.dialogForm[x].value == undefined || this.dialogForm[x].value == null || this.dialogForm[x].value.toString() == '') &&
        (_field != 'wt' && _field != 'id' && _field != 'od') && (_field != 'wtUom' && _field != 'idUom' && _field != 'odUom')) { // MQF-377
        this.dialogForm[x].isValid = false;
        _ret = false;
      }
    }
    if (_ret == false) {
      this.teiasoftToaster.show("error", this.translateService.instant('errors.fieldMandatory'))
      // return false;
    }

    // GBR MQBF-21 04/03/2024 Check numeric OD, ID, WT e quantity
    let _retFormat: boolean = true;
    let _od: any = this.utilsService.checkDecimal(this.dialogForm.filter(x => x.field == 'od')[0].value!);
    if (_od == 'error') {
      this.dialogForm.filter(x => x.field == 'od')[0].isValid = false;
      _retFormat = false;
    } else {
      this.dialogForm.filter(x => x.field == 'od')[0].value = _od;
    }

    let _id: any = this.utilsService.checkDecimal(this.dialogForm.filter(x => x.field == 'id')[0].value!);
    if (_id == 'error') {
      this.dialogForm.filter(x => x.field == 'id')[0].isValid = false;
      _retFormat = false;
    } else {
      this.dialogForm.filter(x => x.field == 'id')[0].value = _id;
    }

    let _wt: any = this.utilsService.checkDecimal(this.dialogForm.filter(x => x.field == 'wt')[0].value!);
    if (_wt == 'error') {
      this.dialogForm.filter(x => x.field == 'wt')[0].isValid = false;
      _retFormat = false;
    } else {
      this.dialogForm.filter(x => x.field == 'wt')[0].value = _wt;
    }

    let _totalW: any = this.utilsService.checkDecimal(this.dialogForm.filter(x => x.field == 'totalWeight')[0].value!);
    if (_totalW == 'error') {
      this.dialogForm.filter(x => x.field == 'totalWeight')[0].isValid = false;
      _retFormat = false;
    } else {
      this.dialogForm.filter(x => x.field == 'totalWeight')[0].value = _totalW;
    }

    let _length: any = this.utilsService.checkDecimal(this.dialogForm.filter(x => x.field == 'length')[0].value!);
    if (_length == 'error') {
      this.dialogForm.filter(x => x.field == 'length')[0].isValid = false;
      _retFormat = false;
    } else {
      this.dialogForm.filter(x => x.field == 'length')[0].value = _length;
    }

    if (!_retFormat) {
      this.teiasoftToaster.show("error", this.translateService.instant('errors.formatNotValid'));
      return false;
    }

    if (!this.checkWtOdId(true)) return false;

    /* let _ret: boolean = true;
    for (var x=0; x < this.dialogForm.length; x++){
      let _field: string = this.dialogForm[x].field!;
      if (this.dialogForm[x].isRequired && (this.dialogForm[x].value == undefined || this.dialogForm[x].value == null || this.dialogForm[x].value.toString() == '') &&
      (_field != 'wt' &&_field != 'id' && _field != 'od')){
        this.dialogForm[x].isValid = false;
        _ret = false;
      }
    }
    if (_ret == false) this.teiasoftToaster.show("error", this.translateService.instant('errors.fieldMandatory')); */
    return _ret;
  }

  isGraterZeroValuesValid(): boolean {
    let _ret: boolean = true;
    let _i: number = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'od');
    if (this.dialogForm[_i].value != null && parseFloat(this.dialogForm[_i].value) <= 0) {
      this.dialogForm[_i].isValid = false;
      _ret = false;
    }

    _i = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'id');
    if (this.dialogForm[_i].value != null && parseFloat(this.dialogForm[_i].value) <= 0) {
      this.dialogForm[_i].isValid = false;
      _ret = false;
    }

    _i = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'wt');
    if (this.dialogForm[_i].value != null && parseFloat(this.dialogForm[_i].value) <= 0) {
      this.dialogForm[_i].isValid = false;
      _ret = false;
    }

    // Please note: if the totalweight is not editable because was calculated by the backend 
    // this validation will be skipped as no necessary
    _i = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'totalweight');
    if (this.dialogForm[_i].value != null && parseFloat(this.dialogForm[_i].value) <= 0 && !this.dialogForm[_i].disabled) {
      this.dialogForm[_i].isValid = false;
      _ret = false;
    }

    _i = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'length');
    if (this.dialogForm[_i].value != null && parseFloat(this.dialogForm[_i].value) <= 0) {
      this.dialogForm[_i].isValid = false;
      _ret = false;
    }

    if (_ret == false) this.teiasoftToaster.show("error", this.translateService.instant('errors.greaterZero'));
    return _ret;
  }

  isValidDate(timestamp: number): boolean {
    const date = new Date(timestamp);
    return !isNaN(date.getTime());
  }

  checkWtOdId(isSave: boolean): boolean {
    let _ret: boolean = true;
    let _iOd: number = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'od');
    let _iOdUom: number = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'oduom');
    let _iId: number = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'id');
    let _iIdUom: number = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'iduom');
    let _iWt: number = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'wt');
    let _iWtUom: number = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'wtuom');

    let _odValue: any = this.dialogForm[_iOd].value ? this.dialogForm[_iOd].value : '';
    let _idValue: any = this.dialogForm[_iId].value ? this.dialogForm[_iId].value : '';
    let _wtValue: any = this.dialogForm[_iWt].value ? this.dialogForm[_iWt].value : '';

    let _odUomValue: any = this.dialogForm[_iOdUom].value ? this.dialogForm[_iOdUom].value : '';
    let _idUomValue: any = this.dialogForm[_iIdUom].value ? this.dialogForm[_iIdUom].value : '';
    let _wtUomValue: any = this.dialogForm[_iWtUom].value ? this.dialogForm[_iWtUom].value : '';

    let _case: string = '';

    // NOT VALID - ALL VALUES NULL
    if (_odValue == '' && _idValue == '' && _wtValue == '') {
      this.dialogForm[_iOd].isRequired = true;
      this.dialogForm[_iOd].isValid = false;

      this.dialogForm[_iOdUom].isRequired = true;
      if (_odUomValue == '') this.dialogForm[_iOdUom].isValid = false;

      this.dialogForm[_iId].isRequired = true;
      this.dialogForm[_iId].isValid = false;

      this.dialogForm[_iIdUom].isRequired = true;
      if (_idUomValue == '') this.dialogForm[_iIdUom].isValid = false;

      this.dialogForm[_iWt].isRequired = true;
      this.dialogForm[_iWt].isValid = false;

      this.dialogForm[_iWtUom].isRequired = true;
      if (_wtUomValue == '') this.dialogForm[_iWtUom].isValid = false;
      _ret = false;
    }

    // NOT VALID - OD VALID, ID NULL, WT NULL
    if (_odValue != '' && _idValue == '' && _wtValue == '') {
      this.dialogForm[_iOd].isRequired = true;
      this.dialogForm[_iOd].isValid = true;
      this.dialogForm[_iOdUom].isRequired = true;
      this.dialogForm[_iOdUom].value = _odUomValue;
      this.dialogForm[_iOdUom].isValid = true;

      this.dialogForm[_iId].isRequired = true;
      this.dialogForm[_iId].isValid = false;
      this.dialogForm[_iIdUom].isRequired = true;
      this.dialogForm[_iIdUom].isValid = (_idUomValue == '') ? false : true;

      this.dialogForm[_iWt].isRequired = true;
      this.dialogForm[_iWt].isValid = false;
      this.dialogForm[_iWtUom].isRequired = true;
      this.dialogForm[_iWtUom].isValid = (_wtUomValue == '') ? false : true;
      _ret = false;
    }

    // NOT VALID - OD NULL, ID VALID, WT NULL
    if (_odValue == '' && _idValue != '' && _wtValue == '') {
      this.dialogForm[_iOd].isRequired = true;
      this.dialogForm[_iOd].isValid = false;
      this.dialogForm[_iOdUom].isRequired = true;
      this.dialogForm[_iOdUom].isValid = (_odUomValue == '') ? false : true;

      this.dialogForm[_iId].isRequired = true;
      this.dialogForm[_iId].isValid = true;
      this.dialogForm[_iIdUom].isRequired = true;
      this.dialogForm[_iIdUom].value = _idUomValue;
      this.dialogForm[_iIdUom].isValid = true;

      this.dialogForm[_iWt].isRequired = true;
      this.dialogForm[_iWt].isValid = false;
      this.dialogForm[_iWtUom].isRequired = true;
      this.dialogForm[_iWtUom].isValid = (_wtUomValue == '') ? false : true;
      _ret = false;
    }

    // NOT VALID - OD NULL, ID NULL, WT VALID
    if (_odValue == '' && _idValue == '' && _wtValue != '') {
      this.dialogForm[_iOd].isRequired = true;
      this.dialogForm[_iOd].isValid = false;
      this.dialogForm[_iOdUom].isRequired = true;
      this.dialogForm[_iOdUom].isValid = (_odUomValue == '') ? false : true;

      this.dialogForm[_iId].isRequired = true;
      this.dialogForm[_iId].isValid = false;
      this.dialogForm[_iIdUom].isRequired = true;
      this.dialogForm[_iIdUom].isValid = (_idUomValue == '') ? false : true;

      this.dialogForm[_iWt].isRequired = true;
      this.dialogForm[_iWt].isValid = true;
      this.dialogForm[_iWtUom].isRequired = true;
      this.dialogForm[_iWtUom].value = _wtUomValue;
      this.dialogForm[_iWtUom].isValid = true;
      _ret = false;
    }

    // 1 VALID - OD VALID, ID VALID, WT NULL
    if (_odValue != '' && _idValue != '' && _wtValue == '') {
      this.dialogForm[_iOd].isRequired = true;
      this.dialogForm[_iOd].isValid = true;
      this.dialogForm[_iOdUom].isRequired = true;
      this.dialogForm[_iOdUom].value = _odUomValue;
      this.dialogForm[_iOdUom].isValid = _odUomValue != '';

      this.dialogForm[_iId].isRequired = true;
      this.dialogForm[_iId].isValid = true;
      this.dialogForm[_iIdUom].isRequired = true;
      this.dialogForm[_iIdUom].value = _idUomValue;
      this.dialogForm[_iIdUom].isValid = _idUomValue != '';

      this.dialogForm[_iWt].isRequired = false;
      this.dialogForm[_iWt].isValid = true;
      this.dialogForm[_iWtUom].isRequired = false;
      this.dialogForm[_iWtUom].isValid = true;
      _case = '1';
    }

    // 2 VALID - OD NULL, ID VALID, WT VALID
    if (_odValue == '' && _idValue != '' && _wtValue != '') {
      this.dialogForm[_iOd].isRequired = true;
      this.dialogForm[_iOd].isValid = true;
      this.dialogForm[_iOdUom].isRequired = false;
      this.dialogForm[_iOdUom].isValid = true;

      this.dialogForm[_iId].isRequired = true;
      this.dialogForm[_iId].isValid = true;
      this.dialogForm[_iIdUom].isRequired = true;
      this.dialogForm[_iIdUom].value = _idUomValue;
      this.dialogForm[_iIdUom].isValid = _idUomValue != '';

      this.dialogForm[_iWt].isRequired = true;
      this.dialogForm[_iWt].isValid = true;
      this.dialogForm[_iWtUom].isRequired = true;
      this.dialogForm[_iWtUom].value = _wtUomValue;
      this.dialogForm[_iWtUom].isValid = _wtUomValue != '';
      _case = '2';
    }

    // 3 VALID - OD VALID, ID NULL, WT VALID
    if (_odValue != '' && _idValue == '' && _wtValue != '') {
      this.dialogForm[_iOd].isRequired = true;
      this.dialogForm[_iOd].isValid = true;
      this.dialogForm[_iOdUom].isRequired = true;
      this.dialogForm[_iOdUom].value = _odUomValue;
      this.dialogForm[_iOdUom].isValid = _odUomValue != '';

      this.dialogForm[_iId].isRequired = true;
      this.dialogForm[_iId].isValid = true;
      this.dialogForm[_iIdUom].isRequired = false;
      this.dialogForm[_iIdUom].isValid = true;

      this.dialogForm[_iWt].isRequired = true;
      this.dialogForm[_iWt].isValid = true;
      this.dialogForm[_iWtUom].isRequired = true;
      this.dialogForm[_iWtUom].value = _wtUomValue;
      this.dialogForm[_iWtUom].isValid = _wtUomValue != '';
      _case = '3';
    }

    // Caso in cui tutti sono compilati (allora metto tutte le uom mandatory e prendo i valori)
    if (_odValue != '' && _idValue != '' && _wtValue != '') {
      this.dialogForm[_iOdUom].isRequired = true;
      this.dialogForm[_iIdUom].isRequired = true;
      this.dialogForm[_iWtUom].isRequired = true;

      this.dialogForm[_iWt].isValid = true;
      this.dialogForm[_iId].isValid = true;
      this.dialogForm[_iOd].isValid = true;

      _case = '4';
    }

    // CHECK REGOLA od>id od>wt
    if (_ret) {
      // Prendo le uom per una corretta valutazione dei dati e porto tutto in millimetri/inches
      let _od: number = 0;
      let _id: number = 0;
      let _wt: number = 0;
      let _i: number = this.dialogForm.findIndex(x => x.field!.toLowerCase() === 'unitsystem');
      let _uomSystem: string = this.dialogForm[_i].value != null ? this.dialogForm[_i].value : '';

      if (_uomSystem.toLowerCase() == 'metric') {
        _od = _odValue * (_odUomValue == 'cm' ? 10 : (_odUomValue == 'dm' ? 100 : (_odUomValue == 'm' ? 1000 : 1)));
        _id = _idValue * (_idUomValue == 'cm' ? 10 : (_idUomValue == 'dm' ? 100 : (_idUomValue == 'm' ? 1000 : 1)));
        _wt = _wtValue * (_wtUomValue == 'cm' ? 10 : (_wtUomValue == 'dm' ? 100 : (_wtUomValue == 'm' ? 1000 : 1)));
      } else {
        _od = _odValue * (_odUomValue == 'thou' ? 0.001 : (_odUomValue == 'ft' ? 12 : (_odUomValue == 'm' ? 36 : 1)));
        _id = _idValue * (_idUomValue == 'thou' ? 0.001 : (_idUomValue == 'ft' ? 12 : (_idUomValue == 'm' ? 36 : 1)));
        _wt = _wtValue * (_wtUomValue == 'thou' ? 0.001 : (_wtUomValue == 'ft' ? 12 : (_wtUomValue == 'm' ? 36 : 1)));
      }


      if ((_case == '1' || _case == '4') && _od <= _id) {
        this.dialogForm[_iOd].isValid = false;
        this.dialogForm[_iId].isValid = false;
        this.teiasoftToaster.show("error", this.translateService.instant('errors.odMajorId'));
        _ret = false;
      }

      if ((_case == '3' || _case == '4') && _od <= (2 * _wt)) {
        this.dialogForm[_iOd].isValid = false;
        this.dialogForm[_iWt].isValid = false;
        this.teiasoftToaster.show("error", this.translateService.instant('errors.odMajorWt'));
        _ret = false;
      }

      if (_case == '4' && (Number((_od - _id)).toFixed(2) != (2 * _wt).toFixed(2))) {
        this.dialogForm[_iOd].isValid = false;
        this.dialogForm[_iWt].isValid = false;
        this.dialogForm[_iId].isValid = false;
        this.teiasoftToaster.show("error", this.translate.instant('errors.odIdWtNotConsistent'));
        _ret = false;
      }

      if (_ret) {
        this.dialogForm[_iOd].isValid = true;
        this.dialogForm[_iId].isValid = true;
        this.dialogForm[_iWt].isValid = true;
      }
    } else {
      if (isSave) this.teiasoftToaster.show("error", this.translateService.instant('errors.wtodidMandatory'));
    }

    _ret = this.dialogForm[_iOd].isValid! && this.dialogForm[_iOdUom].isValid!
      && this.dialogForm[_iId].isValid! && this.dialogForm[_iIdUom].isValid!
      && this.dialogForm[_iWt].isValid! && this.dialogForm[_iWtUom].isValid!

    return _ret;
  }

  valorizeForm(field: string, value: any, text: any) {
    let _i: number = this.dialogForm.findIndex(x => x.field == field);
    if (this.dialogForm[_i].type == 'date' || this.dialogForm[_i].type == 'datetime') {
      const numericValue = value === '' || value == null ? null : Number(value);
      this.dialogForm[_i].value = Number.isFinite(numericValue) ? numericValue : null;
      this.dialogForm[_i].text = this.dialogForm[_i].value;
    } else {
      this.dialogForm[_i].value = value.toString() == '' ? null : value;
      this.dialogForm[_i].text = text;
    }

    // GBR 23/01/2024
    if (this.dialogForm[_i].isRequired)
      this.dialogForm[_i].isValid = (value == undefined || value.length == 0) ? false : true;
    else
      this.dialogForm[_i].isValid = true;

    // GBR 23/01/2024 - Emitto per verificare regole speciali
    let _obj: Autocomplete = new Autocomplete();
    _obj.field = field;
    _obj.object = value;
    this.onFormAutocompleteInputChange.emit(_obj);
  }

  clearEventListener() {
    if (!this.globals.inputHasEvents) return;
    var old_element = document.getElementById("teiasoftDialog");
    var new_element = old_element!.cloneNode(true);
    old_element!.parentNode!.replaceChild(new_element, old_element!);
    this.globals.inputHasEvents = false;
  }

  setRoundDigitsEnquiryForm() {
    // ROUND DIGITS
    if (!this.roundDigitsForEnquiryForm || this.roundDigitsForEnquiryForm.length == 0) return;
    if (!this.dialogForm || this.dialogForm.length == 0) return;

    let _iUS: number = this.dialogForm.findIndex(x => x.field == "unitSystem");
    let _unitSystem: string = this.dialogForm[_iUS].value!;

    let _i: number = -1;
    for (var k = 0; k < this.roundDigitsForEnquiryForm.length; k++) {
      _i = this.dialogForm.findIndex(x => x.field?.toLowerCase() == this.roundDigitsForEnquiryForm[k].fieldName!);
      if (_i != -1) {
        if (_unitSystem == 'Metric' && this.dialogForm[_i].value != null && this.dialogForm[_i].value != '') {
          this.dialogForm[_i].value = parseFloat(this.dialogForm[_i].value).toFixed(this.roundDigitsForEnquiryForm[k].metricDigits!);
          //this.dialogForm[_i].roundDigits = this.roundDigitsForEnquiryForm[k].metricDigits!
        }

        if (_unitSystem == 'Imperial' && this.dialogForm[_i].value != null && this.dialogForm[_i].value != '') {
          this.dialogForm[_i].value = parseFloat(this.dialogForm[_i].value).toFixed(this.roundDigitsForEnquiryForm[k].imperialDigits!);
          //this.dialogForm[_i].roundDigits = this.roundDigitsForEnquiryForm[k].imperialDigits!;
        }

        if (_unitSystem == 'Metric') {
          this.dialogForm[_i].roundDigits = this.roundDigitsForEnquiryForm[k].metricDigits!
        }

        if (_unitSystem == 'Imperial') {
          this.dialogForm[_i].roundDigits = this.roundDigitsForEnquiryForm[k].imperialDigits!;
        }
      }
    }

  }

  /*
    ****************************************** ATTACHMENTS ***********************************
  */
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const relatedTarget = event.relatedTarget as HTMLElement;
    const dropZone = event.currentTarget as HTMLElement;

    // Only unset isDragging if truly leaving the drop zone
    if (!relatedTarget || !dropZone.contains(relatedTarget)) {
      this.isDragging = false;
    }
  }

  onDropFile(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      Array.from(files).forEach((file) => {
        this.processFile(file);
      });
    }
  }

  onFileSelectedAttach(evt: any): void {
    if (!evt.target.files || evt.target.files.length === 0) return;

    Array.from(evt.target.files).forEach((file) => {
      this.processFile(file as File);
    });

    evt.target.value = null; // Clear the input after processing
  }



  processFile(file: File): void {
    this.teiasoftLoader.start();

    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
    const MAX_OVERALL_REQUEST_SIZE = 100 * 1024 * 1024; // 100 MB in bytes
    const fileName = file.name;

    // Check if file exceeds the maximum file size
    if (file.size > MAX_FILE_SIZE) {
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("error", this.translate.instant("errors.maxFileUploadSizeExceeded"));
      return;
    }

    // Calculate the size of current attachments and check overall size constraint
    const actualAttachmentsToUpdateSize = this.attachmentsToUpdate.reduce((prev, curr) =>
      prev + (curr.fileContent ? this.fileSizeInBytes(curr.fileContent) : 0), 0);

    const allItemsToUpdateSize = this.enquiryAttachments.reduce((prev, curr: any) => {
      return prev + (curr && curr.fileContent ? this.fileSizeInBytes(curr.fileContent) : 0);
    }, 0);

    if ((allItemsToUpdateSize + actualAttachmentsToUpdateSize + file.size) > MAX_OVERALL_REQUEST_SIZE) {
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("error", this.translate.instant("errors.maxOverallUploadSizeExceeded"));
      return;
    }

    // Check for duplicate file names
    const isDuplicate = this.attachmentsToUpdate.some((x) => x.fileName === fileName);

    if (isDuplicate) {
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("info", this.translate.instant("info.fileAldreadyLoaded"));
      return;
    }

    // Read file as Base64
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (evt: any) => {
      const base64 = evt.target.result
        .replace('data:', '')
        .replace(/^.+,/, '');

      const attachment: AttachmentToUpdate = {
        fileCreationDate: new Date().getTime(),
        fileName,
        fileContent: base64
      };

      this.attachmentsToUpdate.push(attachment);
      this.teiasoftLoader.stop();
    };
  }


  /**
 * 
 * @param base64 
 * @returns 
 */
  fileSizeInBytes(base64: string): number {
    const base64String = base64.replaceAll('=', '');
    const bytes = base64String.length * (3 / 4);

    return bytes;
  }

  /**
     * CHE ICO TYPE FOR ATTACHMENT
     * @param attach 
     * @returns 
     */
  getFileIcoType(attach: EnquiryAttachment): string {
    let _ret: string = "fas fa-file";

    if (attach.fileName!.endsWith('.txt'))
      return 'fas fa-file';

    if (attach.fileName!.endsWith('.doc') || attach.fileName!.endsWith('.docx'))
      return 'fas fa-file-word';

    if (attach.fileName!.endsWith('.xls') || attach.fileName!.endsWith('.xlsx'))
      return 'fas fa-file-excel';

    if (attach.fileName!.endsWith('.ppt') || attach.fileName!.endsWith('.pptx'))
      return 'fas fa-file-powerpoint';

    if (attach.fileName!.endsWith('.pdf'))
      return 'fas fa-file-pdf';

    if (attach.fileName!.endsWith('.jpg') || attach.fileName!.endsWith('.jpeg') || attach.fileName!.endsWith('.png') || attach.fileName!.endsWith('.svg') || attach.fileName!.endsWith('.gif')
      || attach.fileName!.endsWith('.tiff'))
      return 'fas fa-file-image';

    if (attach.fileName!.endsWith('.zip') || attach.fileName!.endsWith('.7z'))
      return 'fas fa-file-archive';

    if (attach.fileName!.endsWith('.mp4') || attach.fileName!.endsWith('.wav') || attach.fileName!.endsWith('.mov'))
      return 'fas fa-file-video';

    if (attach.fileName!.endsWith('.mp3') || attach.fileName!.endsWith('.wav'))
      return 'fas fa-file-audio';

    return _ret;
  }

  /**
   * GET IF ATTACHMENT IS IN DELETION
   * @param fileId 
   * @returns 
   */
  isInDeletion(fileId: number): boolean {
    if (this.listAttachToDelete.findIndex(x => x.fileId == fileId) != -1)
      return true;
    else
      return false;
  }

  /**
   * OPEN THE ATTACHMENT
   * @param attach 
   */
  onOpenAttach(attach: EnquiryAttachment) {
    let _isPreview: boolean = true;

    if (attach.fileName!.endsWith('.txt'))
      _isPreview = true;

    if (attach.fileName!.endsWith('.doc') || attach.fileName!.endsWith('.docx'))
      _isPreview = false;

    if (attach.fileName!.endsWith('.xls') || attach.fileName!.endsWith('.xlsx'))
      _isPreview = false;

    if (attach.fileName!.endsWith('.ppt') || attach.fileName!.endsWith('.pptx'))
      _isPreview = false;

    if (attach.fileName!.endsWith('.pdf'))
      _isPreview = true;

    if (attach.fileName!.endsWith('.jpg') || attach.fileName!.endsWith('.jpeg') || attach.fileName!.endsWith('.png') || attach.fileName!.endsWith('.svg') || attach.fileName!.endsWith('.gif')
      || attach.fileName!.endsWith('.tiff'))
      _isPreview = true;

    if (attach.fileName!.endsWith('.zip') || attach.fileName!.endsWith('.7z'))
      _isPreview = false;

    if (attach.fileName!.endsWith('.mp4') || attach.fileName!.endsWith('.mov'))
      _isPreview = true;

    if (attach.fileName!.endsWith('.mp3') || attach.fileName!.endsWith('.wav'))
      _isPreview = true;

    ///////// TEMOP VERIFICARE CON LUCA
    window.open(attach.presignedUrl, '_blank');
    /* if (!_isPreview){
      window.open(attach.presignedUrl,'_blank');
    } else {        
      this.selectedAttach = new ItemAttachment();
      this.selectedAttach = attach;
      this.showSelectAttach = true;
    } */
  }

  /** EVENTS */
  onDeleteAttachClick(attach: EnquiryAttachment) {
    // Verifico se è un file appena inserito MQF-151
    /* if (!attach.enquiryAttachmentId) {
      let _temp: AttachmentToUpdate[] = new Array();
      _temp = JSON.parse(JSON.stringify(this.enquiryAttachments));
      this.enquiryAttachments = _temp.filter((k: AttachmentToUpdate) => k["fileName"] != attach["fileName"]);
    } else {
      if (!this.listAttachToDelete) this.listAttachToDelete = new Array();
      let _attachToDelete: EnquiryAttachmentToDelete = new EnquiryAttachmentToDelete();
      _attachToDelete.enquiryNo = this.enquiryNo;
      _attachToDelete.fileId = attach.enquiryAttachmentId!;
      this.listAttachToDelete.push(_attachToDelete);
    } */
    if (!this.listAttachToDelete) this.listAttachToDelete = new Array();
    let _attachToDelete: EnquiryAttachmentToDelete = new EnquiryAttachmentToDelete();
    _attachToDelete.enquiryNo = this.enquiryNo;
    _attachToDelete.fileId = attach.enquiryAttachmentId!;
    this.listAttachToDelete.push(_attachToDelete);
  }

  onCancelDeleteClick(fileId: number) {
    this.listAttachToDelete = this.listAttachToDelete.filter(x => x.fileId != fileId);
  }

  onDeleteAttachToUpdateClick(attach: AttachmentToUpdate) {
    // MQF-151
    this.attachmentsToUpdate = this.attachmentsToUpdate.filter(k => k.fileName != attach.fileName );
  }


  /* 
      ***************************************** EVENTS ***************************************
  */

  // Teiasoft Select Event
  onSelected(evt: SelectOption, field: string) {
    if (!evt) return;
    let _ret: DialogSelect = new DialogSelect();
    _ret.field = field;
    _ret.option = new SelectOption();
    _ret.option = evt;
    this.onFormSelectChanged.emit(_ret);
    this.valorizeForm(field, evt.value, _ret.option.text);
    if (field == 'unitSystem') this.setRoundDigitsEnquiryForm();
  }

  // Teiasoft Input OnInput event
  onInput(evt: any, field: string) {
    this.valorizeForm(field, evt, evt);
  }

  // Teiasoft Input OnFocusOut event
  onInputFocusOut(evt: any, field: string) {
    this.checkWtOdId(false);
  }

  // Teiasoft DateTime change
  onChangeDate(evt: string, field: string) {
    this.valorizeForm(field, evt, evt);
  }

  // Teiasoft list change event
  onSelectList(evt: string, field: string) {
    this.valorizeForm(field, evt, evt);
    let _item: DialogList = new DialogList();
    _item.field = field;
    _item.value = evt;
    this.onFormSelectListChanged.emit(_item);
  }

  // Teiasoft Toggle Changed
  onToggleChanged(evt: ToggleObject) {
    this.onFormToggleChanged.emit(evt);
  }

  // Teiasoft Input Autocomplete select
  onAutocompleteSelect(evt: Autocomplete) {
    this.onFormAutocompleteChanged.emit(evt);
  }

  onAutocompleteSelectRows(evt: Autocomplete) {
    this.onFormAutocompleteChangedRows.emit(evt);
  }

  onAutocompleteLinkClick(evt: any) {
    this.onFormAutocompletLinkClicked.emit(evt)
  }

  onAutocompleteInputChange(evt: any) {
    this.onFormAutocompleteInputChange.emit(evt);
  }

  onAutocompleteRemoveElement(evt: any) {
    this.onFormAutocompleteRemoveElement.emit(evt);
  }

  onDialogButtonClick(evt: any) {
    let _ret: DialogObject = new DialogObject();
    _ret.action = evt;
    _ret.dialogForm = new Array();
    _ret.dialogForm = this.dialogForm!;

    if (this.attachmentsToUpdate && this.attachmentsToUpdate.length > 0) {
      _ret.attachmentsToUpdate = new Array();
      _ret.attachmentsToUpdate = this.attachmentsToUpdate;
    }

    if (this.listAttachToDelete && this.listAttachToDelete.length > 0) {
      _ret.attachmentsToDelete = new Array();
      _ret.attachmentsToDelete = this.listAttachToDelete;
    }

    if (evt == 'save' || evt == 'save-add-items' || evt == 'save-add-items-AI') {
      let _isFormValid: boolean = this.isFormValid();
      let _isValidGreaterThanZero: boolean = this.isGraterZeroValuesValid();
      if (_isFormValid && _isValidGreaterThanZero) {
        //this.clearEventListener(); // Commentato per MQF-138
        this.onButtonClick.emit(_ret);
      } /* else {
        this.teiasoftToaster.show("error", this.translateService.instant('errors.fieldMandatory'));
      } */
    } else if (evt == 'addAttachment') {
      $("#fileUploadAttach").click();
    }
    else if (evt == 'specialRequirements') {
      this.onButtonClick.emit(_ret); // add this handler to avoid break logic below: check why we reset the dialogform ?
    }
    else {
      this.dialogForm = new Array();
      this.dialogForm = JSON.parse(JSON.stringify(this.oldDialogForm));
      _ret.dialogForm = new Array();
      //this.clearEventListener(); // Commentato per MQF-138
      this.onButtonClick.emit(_ret);
    }
  }

  onClickFormButton(evt: any) {
    this.onFormButtonClick.emit(evt);
  }

  onBtnToolbarClick(btn: TTButton) {
    this.onFormButtonClick.emit(btn);
  }

}
